import {
    FETCH_ALL_PROMOTION_SUCCESS, EDIT_PROMOTION, UPDATE_PROMOTION_SUCCESS, CREATE_PROMOTION_SUCCESS, DELETE_PROMOTION_SUCCESS,SET_PROMOTION,SET_ROLE
} from "constants/promotions.constants";

const INIT_STATE = {
    promotions: [],
    promotion_roles:[],
    promotion: {
        id: 0,
        name: '',
        applicable_area:0,
        type:0,
        end_date:'',
        start_date:'',
        doctor_category_id:0,
        code_regex:"",
    }
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.promotion);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                promotion:c
            }
        }
        //set promotion
        case SET_PROMOTION: {
            let c = Object.assign({}, state.promotion);
            c[action.key] = action.value
            return {
                ...state,
                promotion: c
            }
        }
        case FETCH_ALL_PROMOTION_SUCCESS: {
            return {
                ...state,
                promotions: action.payload.data,
                pagination: action.payload.page
            }
        }

        case UPDATE_PROMOTION_SUCCESS: {
            let foundIndex = state.promotions.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.promotions);
            let o =  action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                promotions: all,
                promotion: o,
            }
        }

        case CREATE_PROMOTION_SUCCESS: {
            let all = Object.assign([], state.promotions);
            all.push(action.payload.data)
            return {
                ...state,
                promotions: all,
                promotion: INIT_STATE.promotion
            }
        }

        case DELETE_PROMOTION_SUCCESS: {
            let all = Object.assign([], state.promotions);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                promotions: newArray,
            }
        }

        case EDIT_PROMOTION: {
            let u = state.promotions.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
            o.applicable_area_id = u.applicable_area.id
            o.doctor_category_id =  u.doctor_category.id
           // o.country_id = o.country.id
           // o.promotion_type_id = o.partner_type.id
            return {
                ...state,
                promotion: o
            }
        }

        

        
        default:
            return state;
    }
}